import React, {useEffect, useState} from 'react';
import SmallEditNumber from "./Cmps/SmallEditNumbr/SmallEditNumber";
import commonStyle from "../../common/styles/common";
import {makeStyles} from "@material-ui/core/styles";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
const useStyles = makeStyles(commonStyle);

export default function OneTimeHistoryBody({si, update}) {
    const classes = useStyles();

    return <GridContainer>
        <GridItem md={6}>
            {
                si.Status
                    ? <SmallEditNumber value={si.Designs} id={si.Id} label={"Designs"}
                                       update={update} paramKey="designs"/>
                    : <span>  Designs :&nbsp; <b>{si.Designs}</b></span>
            }
        </GridItem>
        <GridItem md={6} className={classes.contentRight}>
            {
                si.Status
                    ? <SmallEditNumber value={si.DesignsUsed} id={si.Id} label={"Used Designs"}
                                       update={update} paramKey="designs_used"/>
                    : <span>  Designs :&nbsp; <b>{si.DesignsUsed}</b></span>
            }
        </GridItem>
    </GridContainer>
}